class BackToTop {
  constructor() {
    const backToTopBtn = document.querySelector('.back-to-top');
    console.log('button', backToTopBtn);
    backToTopBtn.addEventListener('click', () => {
      console.log('clicked');
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    })
  }
}

export default BackToTop;